import { ButtonSizes } from "@roc-digital/ui-web";
import { Button, ButtonVariants } from "../Button";
import { Heading2 } from "../Typefaces";
import { Modal } from "../Modal";
import { ArticleSchema } from "@roc-digital/mxm-base/src/data";
import { Zone } from "./types";

export function openDeZoneArticleModal(props: DeZoneArticleModalProps) {
  Modal.open('mxm.modal', <DeZoneArticleModal {...props}/>, 'medium');
}

interface DeZoneArticleModalProps {
  article: ArticleSchema,
  zone: Zone;
  onYes: () => void;
}

function DeZoneArticleModal(props: DeZoneArticleModalProps) {

  const closeModal = () => {
    Modal.close('mxm.modal');
  };

  const tags = props.zone.tags || [];

  return <div className="p-8">
    <Heading2 className={'mb-8 text-admin-dark !font-extrabold !text-[26px]'}>Confirm remove article from zone.</Heading2>
    <div>
      <br />
      You are about to remove the article titled "{props.article.title}" from the "{props.zone.title}" zone. <b />
      <br /><br />
      The following tags will be removed from the article:
      <pre>
        {tags.map(tag => {
          return <> - {tag.scope} <br /></>
        })}
      </pre>
      <br />
      This change is immediate.  Are you sure you want to do this?
      <br /><br />
    </div>

    <div>
      <div className="mt-4 flex inline-block gap-2">
        <Button clickEvent={closeModal} size={ButtonSizes.medium} variant={ButtonVariants.secondary}>No</Button>
        <span className="flex-grow"></span>
        <Button clickEvent={() => {
          closeModal();
          props.onYes();
        }} size={ButtonSizes.medium}>Yes</Button>
      </div>
    </div>
  </div>
}